import { Checkbox } from 'cdk-radial';
import styled from 'styled-components';

export const StyledCheckboxRenderer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledCheckbox = styled(Checkbox)`
  min-height: 29px;
`;

export const StyledTableHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2em;
`;

export const StyledTextContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const StyledInnerTextContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
`;

export const StyledSpanTextContainer = styled.span`
  display: block;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledHeaderTextContainer = styled.div`
  display: flex;
  align-items: center;
  width: 120px;
`;
